import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_GESTAO_DE_DEMANDAS = `${modulo.GESTAO_DE_DEMANDAS}/paineis`

const actions = {
  async getTimeById ({ commit }, id) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_GESTAO_DE_DEMANDAS}/time?id=${id}`
    })
  },

  async findUsuarios ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_GESTAO_DE_DEMANDAS}/usuarios`
    })
  },

  async setTime ({ commit }, time) {
    return axios({
      method: 'post',
      loader: false,
      url: `${URL_GESTAO_DE_DEMANDAS}/setTime`,
      data: time
    })
  },

  async findByFilter ({ commit }, filtro) {
    return axios({
      method: 'post',
      loaderText: 'Carregando ...',
      url: `${URL_GESTAO_DE_DEMANDAS}/findByFilter`,
      data: filtro
    })
  },

  async findAll ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_GESTAO_DE_DEMANDAS}/findAll`
    })
  },

  async findById ({ commit }, id) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_GESTAO_DE_DEMANDAS}?id=${id}`
    })
  },

  async save ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      loaderText: 'Carregando ...',
      data: dados,
      url: URL_GESTAO_DE_DEMANDAS
    })

    return data
  },

  async delete ({ commit }, id) {
    return axios({
      method: 'delete',
      loaderText: 'Carregando ...',
      url: `${URL_GESTAO_DE_DEMANDAS}?id=${id}`
    })
  },

  async findTimesByPaineis ({ commit }, paineis) {
    return axios({
      method: 'post',
      loaderText: 'Carregando ...',
      url: `${URL_GESTAO_DE_DEMANDAS}/findTimesByPaineis`,
      data: paineis
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/demandas/paineis.js